import { removeTypename } from '@cosuno/apollo';
import type { CompanyFeatureFlags, UserFeatureFlags } from '@cosuno/feature-flags-frontend';
import omit from 'lodash/omit';

import type { CurrentUser_me } from './types';

export const mapToUserFeatureFlags = (user: CurrentUser_me): UserFeatureFlags =>
  user.featureFlags as UserFeatureFlags;

export const mapToCompanyFeatureFlags = (user: CurrentUser_me): CompanyFeatureFlags => {
  const { company } = removeTypename(user);

  return {
    ...omit(company.config, 'id', 'additionalLanguages'),
    ...(company.permanentFeatureFlags as CompanyFeatureFlags),
  } as const;
};
